import { apiHelper } from "app/common/services/apiHelper";

import { AppsResourceService } from "./AppsResourceService";
import { fetchSimilarSitesQuery } from "./sitesService/queries/sitesQueries";

interface MainItemParams {
    type: "Mobile" | "Website";
    name: string;
    appStore?: string;
}

export const SimilarItemsService = {
    async getSimilarItems(mainItemParams: MainItemParams, maxResults?: number): Promise<unknown> {
        const _maxResults = maxResults || 20;
        switch (mainItemParams.type) {
            case "Mobile":
                let params: Record<string, unknown> = {};
                if (mainItemParams.appStore !== "both") {
                    params.store = mainItemParams.appStore;
                }
                params = apiHelper.transformParamsForAPI(params);
                params.appId = mainItemParams.name;

                return AppsResourceService.similarApps(params);
            case "Website":
                return fetchSimilarSitesQuery(mainItemParams.name, { limit: _maxResults });
        }
    },
};
